import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import './ServiceCard.css';

interface ServiceCardProps {
  title: string;
  description: string;
  features?: string[];
  ctaText: string;
  ctaLink: string;
  image?: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  description,
  features,
  ctaText,
  ctaLink,
  image,
}) => {
  return (
    <div className="service-card">
      {image && (
        <div className="service-card-image">
          <img src={image} alt={title} loading="lazy" />
        </div>
      )}
      <div className="service-card-content">
        <h3 className="service-card-title">{title}</h3>
        <p className="service-card-description">{description}</p>
        {features && (
          <ul className="service-card-features">
            {features.map((feature, idx) => (
              <li key={idx}>
                <span className="feature-dot" />
                {feature}
              </li>
            ))}
          </ul>
        )}
        <Link to={ctaLink} className="service-card-cta">
          {ctaText} <FaArrowRight />
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard;
